import React from 'react';
import TextContainer from '../TextContainer';
import { withStyles, Typography, Grid } from '@material-ui/core';
import styles from './Gallery.css';
import TextDivider from '../TextDivider';

function Gallery(props) {

    const {classes} = props;

    return (
        <div className={classes.gallery}>
            <TextContainer>

                <Typography variant="h5">Gallery</Typography>
                <br></br>
                <Typography variant="body1">
                    Want to participate? Submit your images to <a href='mailto:nucleaizer@gmail.com'>nucleaizer@gmail.com</a>.
                </Typography>

                <TextDivider></TextDivider>

                <Typography variant="h6">
                    Our own favorites
                </Typography>

                
                <Grid container spacing={24}>
                    <Grid item xs={6} className={classes.gridItem}>
                        <img src={process.env.PUBLIC_URL + "/images/gallery/favourite_1_input.png"} alt="BIOMAG" className={classes.gridImage}></img>
                    </Grid>
                    <Grid item xs={6} className={classes.gridItem}>
                        <img src={process.env.PUBLIC_URL + "/images/gallery/favourite_1_segmentation.png"} alt="BIOMAG" className={classes.gridImage}></img>
                    </Grid>
                </Grid>


                <TextDivider></TextDivider>

                <Typography variant="h6">
                    A 96×96 image
                </Typography>

                
                <Grid container spacing={24} classes={{container: classes.gridContainer}}>
                    <Grid item xs={6} className={classes.gridItem}>
                        <img src={process.env.PUBLIC_URL + "/images/gallery/96x96_small.png"} alt="BIOMAG" style={{height: '96px', width: '96px'}}></img>
                    </Grid>
                    <Grid item xs={6} className={classes.gridItem}>
                        <img src={process.env.PUBLIC_URL + "/images/gallery/96x96_large.png"} alt="BIOMAG" className={classes.gridImage}></img>
                    </Grid>
                </Grid>


                <TextDivider></TextDivider>

                <Typography variant="h6">
                    Demonstrating scale insensitivity
                </Typography>

                <Grid container spacing={24} className={classes.gridContainer}>
                    <Grid item xs={12} className={classes.gridItem}>
                        <img 
                            src={process.env.PUBLIC_URL + "/images/gallery/ready01_w.png"} 
                            alt="BIOMAG" 
                            className={classes.gridImage}
                        />
                    </Grid>
                    <Grid item xs={12} className={classes.gridItem}>
                        <img 
                            src={process.env.PUBLIC_URL + "/images/gallery/ready04_w.png"} 
                            alt="BIOMAG" 
                            className={classes.gridImage}
                        />   
                    </Grid>
                </Grid>

            </TextContainer>
        </div>
    );
}

export default withStyles(styles, {withTheme: true})(Gallery);
